var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeetingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.500122,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#1D4469",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31208_26352)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8569 9.37094C11.8569 10.1201 11.2489 10.7281 10.4997 10.7281C9.75058 10.7281 9.14258 10.1201 9.14258 9.37094C9.14258 8.62179 9.75058 8.01379 10.4997 8.01379C11.2489 8.01379 11.8569 8.62179 11.8569 9.37094Z",
    fill: "#1D4469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24294 10.7282C7.9925 10.7282 8.60014 10.1206 8.60014 9.37099C8.60014 8.62143 7.9925 8.01379 7.24294 8.01379C6.49338 8.01379 5.88574 8.62143 5.88574 9.37099C5.88574 10.1206 6.49338 10.7282 7.24294 10.7282Z",
    fill: "#1D4469"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3994 9.37094C12.3994 8.62179 13.0074 8.01379 13.7566 8.01379C14.5057 8.01379 15.1137 8.62179 15.1137 9.37094C15.1137 10.1201 14.5057 10.7281 13.7566 10.7281C13.0074 10.7281 12.3994 10.1201 12.3994 9.37094Z",
    fill: "#1D4469"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9424 13.1716V13.7145C12.9424 13.7864 12.9139 13.8556 12.8628 13.9064C12.8121 13.9574 12.7429 13.9859 12.6709 13.9859H8.32807C8.25614 13.9859 8.18693 13.9574 8.13617 13.9064C8.08514 13.8556 8.05664 13.7864 8.05664 13.7145V13.1716C8.05664 12.1223 8.9073 11.2716 9.95664 11.2716H11.0424C12.0917 11.2716 12.9424 12.1223 12.9424 13.1716Z",
    fill: "#1D4469"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.439 13.9859H15.9286C16.0005 13.9859 16.0697 13.9574 16.1205 13.9064C16.1715 13.8556 16.2 13.7864 16.2 13.7145V13.1716C16.2 12.1223 15.3494 11.2716 14.3 11.2716H13.2143C13.0254 11.2716 12.8433 11.299 12.6709 11.3503C13.1711 11.7976 13.4857 12.448 13.4857 13.1716V13.7145C13.4857 13.8078 13.4697 13.8996 13.439 13.9859Z",
    fill: "#1D4469"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32892 11.3503C8.15656 11.299 7.97416 11.2716 7.78552 11.2716H6.6998C5.65046 11.2716 4.7998 12.1223 4.7998 13.1716V13.7145C4.7998 13.7864 4.82831 13.8556 4.87933 13.9064C4.93009 13.9574 4.9993 13.9859 5.07123 13.9859H7.56078C7.5301 13.8996 7.51409 13.8078 7.51409 13.7145V13.1716C7.51409 12.448 7.82868 11.7976 8.32892 11.3503Z",
    fill: "#1D4469"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31208_26563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4.5 5.00012)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingIcon);
export default __webpack_public_path__ + "static/media/MeetingIcon.c8ed7603e4b62b5e432c0a2a3cc625bd.svg";
export { ForwardRef as ReactComponent };